import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  height: 100%;
  display: flex;
  flex-direction: column;
  
  ${props => props.hoverable && `
    &:hover {
      transform: translateY(-5px);
      box-shadow: var(--shadow-lg);
    }
  `}
  
  ${props => props.variant === 'outlined' && `
    box-shadow: none;
    border: 1px solid var(--primary-light);
  `}
  
  ${props => props.variant === 'filled' && `
    background-color: var(--primary);
    color: var(--white);
  `}
`;

const CardHeader = styled.div`
  margin-bottom: var(--spacing-md);
`;

const CardIcon = styled.div`
  margin-bottom: var(--spacing-md);
  color: ${props => props.variant === 'filled' ? 'var(--white)' : 'var(--primary)'};
  font-size: var(--font-size-2xl);
  
  img, svg {
    width: 48px;
    height: 48px;
  }
`;

const CardTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-sm);
  color: ${props => props.variant === 'filled' ? 'var(--white)' : 'var(--text-primary)'};
`;

const CardContent = styled.div`
  flex: 1;
  color: ${props => props.variant === 'filled' ? 'var(--white)' : 'var(--text-secondary)'};
`;

const CardFooter = styled.div`
  margin-top: var(--spacing-md);
  display: flex;
  justify-content: ${props => props.align || 'flex-start'};
`;

const Card = ({
  children,
  title,
  icon,
  footer,
  footerAlign = 'flex-start',
  variant = 'default',
  hoverable = false,
  className,
  ...props
}) => {
  return (
    <CardContainer variant={variant} hoverable={hoverable} className={className} {...props}>
      {icon && <CardIcon variant={variant}>{icon}</CardIcon>}
      
      {title && (
        <CardHeader>
          <CardTitle variant={variant}>{title}</CardTitle>
        </CardHeader>
      )}
      
      <CardContent variant={variant}>{children}</CardContent>
      
      {footer && (
        <CardFooter align={footerAlign}>
          {footer}
        </CardFooter>
      )}
    </CardContainer>
  );
};

export default Card;
